function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="mx-5 my-3 d-flex flex-column justify-content-around">
            <div className="my-3 d-flex flex-column justify-content-center align-items-center">
                <h1 className="my-3">Get In Touch</h1>
                <h3 className="mt-3">Let's build your AI-powered future together.</h3>
            </div>
            
            <div className="my-5 d-flex flex-column flex-md-row justify-content-start justify-content-md-around">
                <div>
                    <h3 className="text-accent">Where to Find Us</h3>
                    <p>
                    585 Grove St, Ste 145<br/> 
                    Herndon, VA 20170<br/>
                    USA
                    </p>
                    <p>
                    49/8, 60 Ft Rd<br/> 
                    5th Block, Koramangala Industrial Layout<br/> 
                    Bangalore 560095<br/> 
                    India
                    </p>
                </div>
    
                <div>
                    <h3 className="text-accent">Contact Us</h3>
    
                    <ul>
                        <li key={1}><a href="mailto:info@allteam.com"><span>info@allteam.com</span></a></li>
                        <li key={2}><a href="tel:+16466031779"><span>+1 646-603-1779</span></a></li>
                        <li key={3}>
                            <div className="d-flex flex-row">
                                <a href="tel:+19198887857">
                                    <span>+1 919-888-7857</span>
                                </a>
                                <a href="https://wa.me/+19198887857?text=Hello%20there!" target="_blank" rel="noreferrer" className="ms-2">
                                    <i className="bi bi-whatsapp"></i>
                                </a>
                            </div>
                        </li>
                        <li key={4}><a href="tel:+919916906403"><span>+91-99169-06403</span></a></li>
                        <li key={9}>
                            <div className="mt-3">
                            <i className="me-2 bi bi-linkedin"></i>
                            <i className="me-2 bi bi-facebook"></i>
                            <i className="me-2 bi bi-twitter-x"></i>
                            <i className="me-2 bi bi-instagram"></i>
                            <i className="bi bi-youtube"></i>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="footer-tagline-container">
                    <div className="footer-tagline">
                        GROWTH
                        <span>GROWTH</span>
                        <span>GROWTH</span>
                        <span>PROFIT</span>
                    </div>
                </div>
            </div>

            <div className="d-flex flex-row justify-content-center">
                <h6 className="text-secondary">{`© Allteam Outsourcing Pvt Ltd | All Rights Reserved | ${currentYear}`}</h6> 
            </div>        
        </div>
    )
}

export default Footer;